// messageConstants.js
'use strict';

export const MessageMoreFeature = {
  REPORT: 'report',
  BLOCK: 'block',
  FOLLOW: 'follow',
  SHARE: 'share',
  COPY: 'copy',
  PROFILE: 'profile',
  DELETE: 'delete',
};

export const MessageCtaType = {
  PRODUCT: 'product',
  POST: 'post',
  LIVESTREAM: 'livestream',
};
